// extracted by mini-css-extract-plugin
export default {"container_layout":"Layout_container_layout__+y1u+"};